var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserlocationtag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.131,
    height: 8.207,
    viewBox: "0 0 7.131 8.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M3.57,4.834A1.469,1.469,0,0,0,5.08,3.4,1.511,1.511,0,0,0,3.57,1.919,1.469,1.469,0,0,0,2.06,3.351,1.549,1.549,0,0,0,3.57,4.834ZM1.036.947A3.719,3.719,0,0,1,6.1.947a3.273,3.273,0,0,1,0,4.807L3.57,8.157l-2.534-2.4A3.362,3.362,0,0,1,1.036.947Z",
    transform: "translate(-0.025 0.05)",
    fill: "#373334",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserlocationtag);
export default __webpack_public_path__ + "static/media/userlocationtag.6b959fd2fa4bf1101970ddd681adf92a.svg";
export { ForwardRef as ReactComponent };